import Vue from 'vue'
import VeeValidate from 'vee-validate';


// Basic attributes
let en_attributes = {

    // Registration
    firstName: 'first name',
    lastName: 'last name',
    mobileNumber: 'mobile number',
    country: 'country',
    acceptedTerms: 'terms and conditions',

    // Edit Reminder
    type: 'connection',
    message: 'message',
    mobileNumberID: 'mobile number',
    customMobileID: 'mobile number',
};


// Looped attributes
for(let i = 0; i < 10; i++) {

    // Edit Reminder
    en_attributes['type[' + i + ']']            = en_attributes.type;
    en_attributes['message[' + i + ']']         = en_attributes.message;
    en_attributes['customMobileID[' + i + ']']  = en_attributes.customMobileID;

}


// Apply validation
Vue.use(VeeValidate, {
    locale: 'en',
    dictionary: {
        en: {
            attributes: en_attributes
        }
    }
});
